import React from 'react';
import cn from 'classnames';
import { Money } from '../../../Money';
import { format } from '../../../utils';
import { useTheme } from '../../../theme';
import { CdnIcon } from '@shared/ui';
import CircularProgress from '@mui/material/CircularProgress';
const Day = ({ className, date, price, hidePrice, isBestPrice, isSchedule, selected, loading, disabled, moneyRoundType, onSelect }) => {
    const formattedDate = format(date, 'd MMM'), formattedDay = format(date, 'EEEEEE');
    const theme = useTheme('WeekCalendar').DayStyles;
    const isLoadingOrDisabled = loading || disabled;
    const showPrice = price && !hidePrice && !isLoadingOrDisabled;
    const showCircularProgress = loading && !disabled;
    const isSelected = selected && !isLoadingOrDisabled;
    const handleSelect = () => {
        if (!onSelect || isLoadingOrDisabled) {
            return;
        }
        onSelect(date);
    };
    return (React.createElement("div", { className: cn(theme.root, className, {
            [theme.bestPrice]: isBestPrice,
            [theme.schedule]: isSchedule,
            [theme.selected]: isSelected,
            [theme.loading]: loading,
            [theme.disabled]: disabled
        }), onClick: handleSelect },
        React.createElement("div", { className: theme.content },
            React.createElement("div", { className: theme.date }, formattedDate),
            React.createElement("div", { className: theme.day__wrapper },
                React.createElement("div", { className: theme.dashed }),
                React.createElement("span", { className: theme.day }, formattedDay),
                React.createElement("div", { className: theme.dashed })),
            React.createElement("div", { className: theme.price__wrapper },
                showPrice && React.createElement(Money, { moneyClassName: theme.price, money: price, roundType: moneyRoundType }),
                showCircularProgress && (React.createElement(CircularProgress, { classes: {
                        colorPrimary: theme.circularProgress__colorPrimary
                    }, variant: "indeterminate", color: "primary", size: 16 })),
                disabled && React.createElement(CdnIcon, { className: theme.disabledIcon, icon: "Info/Not included" })))));
};
export default Day;
